/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.message_modal_replies = {

  build_reply_node(msg_id) {
    const msg_node = $(`.js-msg[data-id=${msg_id}]`);
    const msg_node_clone = msg_node.clone();
    const msg_bucket_clone = msg_node.closest(".js-msg-bucket").clone();
    msg_bucket_clone.removeClass("msg-day-container--inbound")
      .addClass("msg-day-container mt-1")
      .find(".js-msg").remove();
    const reply_node = $(msg_bucket_clone).append(msg_node_clone);
    return reply_node;
  },

  populate_reply(msg_node) {
    // Append reply
    $("#modal-new-message").addClass("js-reply-modal");
    const new_msg_modal_root = $("#modal-new-message").closest(".modal-wrapper");
    new_msg_modal_root.find(".js-message-modal-title").text("Reply to " + $(msg_node).find(".name").text());
    new_msg_modal_root.find(".js-message-modal-content").prepend("<div class='msg-single js-slideupable'></div>");
    return new_msg_modal_root.find(".msg-single").append(msg_node);
  },

  clear_reply() {
    // console.log "in clear_reply"
    const new_msg_modal_root = $("#modal-new-message").closest(".modal-wrapper");
    new_msg_modal_root.find(".js-message-modal-content").find(".msg-single").remove();
    new_msg_modal_root.find("#modal-new-message").removeClass("js-reply-modal");
    return new_msg_modal_root.find(".js-message-modal-title").text("Send a New Message");
  }
};
